import { AdminHomePage } from "pages/admin/Home";
import AdminPendingRequestsPage from "pages/admin/Requests/PendingRequests";
import AdminCustomerPage from "pages/admin/User/Customer";
import AdminServiceProviderPage from "pages/admin/User/ServiceProvider";
import AdminVehicleFuelPage from "pages/admin/VehicleSettings/FuelType";
import AdminVehicleManufacturerPage from "pages/admin/VehicleSettings/Manufacturer";
import AdminVehicleModelsPage from "pages/admin/VehicleSettings/Models";
import RsaLiveOpsPage from "pages/admin/Rsa/LiveOps";
import RsaVendorsPage from "pages/admin/Rsa/Vendors";
import RsaFeesPage from "pages/admin/Rsa/Fees";
import RsaPaymentsPage from "pages/admin/Rsa/Payments";
import RsaAnalyticsPage from "pages/admin/Rsa/Analytics";


export const adminRoutes = [
    {
        id: 1,
        link: 'admin/home',
        component: <AdminHomePage/>
    },
    {
        id: 2,
        link: 'admin/user',
        subList: [
            {
                id: 21,
                link: 'customer',
                component: <AdminCustomerPage/>
            },
            {
                id: 22,
                link: 'serviceProvider',
                component: <AdminServiceProviderPage/>
            }
        ]
    },
    {
        id: 3,
        link: 'admin/vehicleSettings',
        subList: [
            {
                id: 31,
                link: 'manufacturers',
                component: <AdminVehicleManufacturerPage/>
            },
            {
                id: 32,
                link: 'models',
                component: <AdminVehicleModelsPage/>
            },
            {
                id: 33,
                link: 'fuelType',
                component: <AdminVehicleFuelPage/>
            }
        ]
    },
    {
        id: 4,
        link: 'admin/requests',
        subList: [
            {
                id: 41,
                link: 'pendingRequests',
                component: <AdminPendingRequestsPage/>
            },
        ]
    },
    {
        id: 5,
        link: 'admin/rsa',
        subList: [
            {
                id: 51,
                link: 'live',
                component: <RsaLiveOpsPage/>
            },
            {
                id: 52,
                link: 'vendors',
                component: <RsaVendorsPage/>
            },
            {
                id: 53,
                link: 'fees',
                component: <RsaFeesPage/>
            },
            {
                id: 54,
                link: 'payments',
                component: <RsaPaymentsPage/>
            },
            {
                id: 55,
                link: 'analytics',
                component: <RsaAnalyticsPage/>
            },
        ]
    },
    {
        id: 6,
        link: 'admin',
        component: <AdminHomePage/>
    }
]